import React from "react";
import Navbar from "../../Shared/NavBar/Navbar";
import StarterMainContent from "./Components/StarterMainContent";

const Starter = () => {
  return (
    <div className=" main-wrapper">
      <Navbar />
      <StarterMainContent />
    </div>
  );
};

export default Starter;
